import { IThunkAction } from 'types/IThunkAction';
import { errorHandler } from 'client/helpers/errorHandler';
import { startLoading, stopLoading } from 'client/_redux/actions/loading';
import * as UserServices from 'client/_redux/services/user';
import { UserInvoiceTypes } from 'client/_redux/types/userInvoiceTypes';

export const getMyInvoices = (): IThunkAction => async (dispatch) => {
  dispatch(startLoading());
  try {
    const invoices = await UserServices.getMyInvoices();

    dispatch({ type: UserInvoiceTypes.GET_INVOICES_SUCCESS, payload: invoices });
  } catch (error) {
    dispatch({ type: UserInvoiceTypes.GET_INVOICES_FAILURE });
    errorHandler(error);
  }
  dispatch(stopLoading());
};
